



























import { mapGetters } from 'vuex'
import { Box, Button, CustomLink, Flex } from '../../atoms'
import { PasswordInputGroup } from '../../molecules'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    Box,
    Button,
    PasswordInputGroup,
    CustomLink,
    Flex
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  }
})
export default class RegisterBox extends Vue {
  @Prop({ required: true, type: String }) readonly value!: string
  @Prop({ required: true, type: String }) readonly email!: string
  @Prop({ type: String, default: '' }) readonly error?: string
  @Prop({ type: Boolean, default: false }) readonly formError?: boolean
  @Prop({ type: Boolean, default: false }) readonly disabledSubmitted?: boolean
  goToForgotPassword() {
    this.$router.push({ path: '/forgot-password', query: { email: this.$route?.query?.email } })
  }
}
